import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography';
import { colorsNew } from 'root/src/client/web/commonStyles';
import { resolveLinkMarketingCopy } from 'root/src/shared/util/resolveLinkMarketingCopy';
import { useUserData } from 'root/src/client/v2/userData/hooks/useUserData';
export function ChatMessagePreview({ linkMarketingCopy, url }) {
    var _a, _b;
    const { userData } = useUserData();
    const displayName = (_b = (_a = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : 'You';
    const message = resolveLinkMarketingCopy(linkMarketingCopy, url);
    const parts = message.split(/(https?:\/\/\S+)/g);
    return (<div className="w-full max-w-[480px] rounded bg-dark-2 p-3">
			<Typography variant={typographyVariants.mini} color={colorsNew.light5} className="mb-2">
				CHAT PREVIEW
			</Typography>
			<div className="rounded border border-[#a970ff]" style={{ borderLeftWidth: 4 }}>
				<div className="flex items-center gap-1.5 px-2 py-1">
					<svg width="16" height="16" viewBox="0 0 24 24" fill="#a970ff">
						<path fillRule="evenodd" clipRule="evenodd" d="m13 17 9 5V2l-9 5H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3v5h2v-5h4Zm7-11.601-6 3.333v6.536l6 3.333V5.399ZM4 9h8v6H4V9Z"/>
					</svg>
					<span className="text-xs font-semibold text-[#a970ff]">
						Announcement
					</span>
				</div>
				<div className="flex items-start gap-1.5 px-2 pb-2">
					<span className="text-sm font-bold text-[#5f9ea0]">
						{displayName}
					</span>
					<span className="text-xs text-white" style={{ color: '#efeff1' }}>
						:
					</span>
					<span className="text-sm text-white break-all">
						{parts.map(part => (/^https?:\/\//.test(part) ? (<a key={part} href={part} target="_blank" rel="noopener noreferrer" className="text-[#a970ff] underline">
									{part}
								</a>) : (<span key={part}>{part}</span>)))}
					</span>
				</div>
			</div>
		</div>);
}
